export function formatPhone(celular) {
  if(!celular){
    return '';
  }
  celular = celular.replace(/\D/g,"")

  celular = celular.replace(/(\d{3})(\d{3})(\d{2})(\d{2})$/,"$1 $2 $3 $4"); 

  return celular;
}

export function formatIdentification(identification) {
  identification = identification.replace(/\D/g,"");
  if(identification.length <= 9) {
    identification = identification.replace(/(\d{1,3})(\d{3})(\d{3})$/,"$1.$2.$3"); 
  } else {
    identification = identification.replace(/(\d{1})(\d{1,3})(\d{1,3})(\d{1,3})$/,"$1.$2.$3.$4"); 
  }
  return identification
}
